import APIService from "./APIService";

class GoogleService extends APIService {
  checkAddress = async ({ address_1, address_2, city, state, zip_code, country }: any) => {
    const result = await this.get(
      "google/address?address_1=" +
        address_1 +
        "&address_2=" +
        address_2 +
        "&city=" +
        city +
        "&state=" +
        state +
        "&zip_code=" +
        zip_code +
        "&country=" +
        country
    );
    return result ? result.data : null;
  };
}

export default GoogleService;
